import { render } from "./NcrmMailjetEventsTab.vue?vue&type=template&id=0b9a0bc6&scoped=true"
import script from "./NcrmMailjetEventsTab.vue?vue&type=script&lang=js"
export * from "./NcrmMailjetEventsTab.vue?vue&type=script&lang=js"

import "./NcrmMailjetEventsTab.vue?vue&type=style&index=0&id=0b9a0bc6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9a0bc6"]])

export default __exports__